import { LoginButton } from '../LoginButton';
import { ELoginMethods } from '../../Helper/enums';

interface IFacebookLoginProps {
  appId: string;
  loginButtonClickWrapper: Function;
  translations: Record<string, string>;
}

export const FacebookLogin: React.FC<IFacebookLoginProps> = ({
  loginButtonClickWrapper,
  appId,
  translations,
}) => {
  const loginHandler = async () => {
    window.location.href = `https://www.facebook.com/v17.0/dialog/oauth?response_type=token&client_id=${appId}&redirect_uri=${window.location.origin}${window.location.pathname}&state=facebookredirect`;
  };

  return (
    <LoginButton
      variant="facebook"
      callback={() =>
        loginButtonClickWrapper(loginHandler, ELoginMethods.FACEBOOK)
      }
      text={translations?.signInWithFacebook || 'Sign in with Facebook'}
    >
      <img
        src="https://media.appcharge.com/defaults/facebook_icon_white.svg"
        alt="facebook icon"
      />
    </LoginButton>
  );
};
